// CarFax icon - the "C" box from the official CARFAX logo

export function CarFaxIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.7 71" width={24} height={24} style={{ stroke: 'none' }}>
            {/* White background with rounded corners */}
            <path d="M7.1 0C3.2 0 0 3.1 0 7v57c0 3.8 3.2 7 7.1 7h48.5c3.9 0 7.1-3.1 7.1-7V7c0-3.8-3.2-7-7.1-7H7.1z" fill="#FFF"/>
            {/* Black border */}
            <path d="M3 64V7c0-2.2 1.8-3.9 4.1-3.9h48.5c2.2 0 4.1 1.8 4.1 3.9v57c0 2.2-1.8 3.9-4.1 3.9H7.1C4.8 67.9 3 66.2 3 64zM7.1 0C3.2 0 0 3.1 0 7v57c0 3.8 3.2 7 7.1 7h48.5c3.9 0 7.1-3.1 7.1-7V7c0-3.8-3.2-7-7.1-7H7.1z" fill="#000"/>
            {/* Black box for C section */}
            <path fill="#000" d="M6 65.1h53.6V5.901H6z"/>
            {/* White C letter */}
            <path d="M35.7 56.3c-11.8 0-18-8.7-18-20.4 0-12.7 7.5-20.4 18.1-20.4 9.7 0 13.6 4.2 16.3 11.6l-10 3.9c-1.4-3.7-2.8-6-6.4-6-4.6 0-6.6 4.6-6.6 10.9 0 6.1 1.9 10.9 6.7 10.9 3.4 0 4.9-1.9 7.1-5.6l9.3 4.9c-2.7 5.1-7.1 10.2-16.5 10.2" fill="#FFF"/>
        </svg>
    );
}
